//todo use compiled when @atlaskit/image supports it
//the image is moved to a separate file due to
//https://atlassian.slack.com/archives/CFJ9DU39U/p1691750071893489
import css from '@emotion/css';
import React from 'react';

import Image from '@atlaskit/image';

import PremiumPopupHeaderImageDark from './assets/premiumPopupHeader-Dark.svg';
import PremiumPopupHeaderImageLight from './assets/premiumPopupHeader-Light.svg';
import StandardPopupHeaderImageLight from './assets/standardPopupHeader-Light.svg';
import StandardPopupHeaderImageDark from './assets/standardPopupHeader-Dark.svg';

const imageStyles = css`
	width: 100%;
	height: 100% !important;
	border-radius: 16px 16px 0 0;
	object-position: right;
`;

const imageStylesPremium = css`
	transform: scale(1.25);
`;

const imageStylesStandard = css`
	object-fit: contain;
`;

export function StandardImage() {
	return (
		<Image
			src={StandardPopupHeaderImageLight}
			srcDark={StandardPopupHeaderImageDark}
			css={[imageStyles, imageStylesStandard]}
		/>
	);
}
export function PremiumImage() {
	return (
		<Image
			src={PremiumPopupHeaderImageLight}
			srcDark={PremiumPopupHeaderImageDark}
			css={[imageStyles, imageStylesPremium]}
		/>
	);
}
